export default __webpack_public_path__ + "static/media/HaitianRevolution.db4c3e3b.png";